export const setKey = [
  "",
  "Adventurer", //Adventurer
  "ArchaicPetra", //Archaic Petra
  "Berserker", //Berserker
  "BlizzardStrayer", //Blizzard Strayer
  "BloodstainedChivalry", //Bloodstained Chivalry
  "BraveHeart", //Brave Heart
  "CrimsonWitchOfFlames", //Crimson Witch of Flames
  "DeepwoodMemories", //Deepwood Memories
  "DefendersWill", //Defender's Will
  "DesertPavilionChronicle", //Desert Pavilion Chronicle
  "EchoesOfAnOffering", //Echoes of an Offering
  "EmblemOfSeveredFate", //Emblem of Severed Fate
  "FlowerOfParadiseLost", //Flower of Paradise Lost
  "Gambler", //Gambler
  "GildedDreams", //Gilded Dreams
  "GladiatorsFinale", //Gladiator's Finale
  "HeartOfDepth", //Heart of Depth
  "HuskOfOpulentDreams", //Husk of Opulent Dreams
  "Instructor", //Instructor
  "Lavawalker", //Lavawalker
  "LuckyDog", //Lucky Dog
  "MaidenBeloved", //Maiden Beloved
  "MartialArtist", //Martial Artist
  "NoblesseOblige", //Noblesse Oblige
  "OceanHuedClam", //Ocean-Hued Clam
  "PaleFlame", //Pale Flame
  "PrayersForDestiny", //Prayers for Destiny
  "PrayersForIllumination", //Prayers for Illumination
  "PrayersForWisdom", //Prayers for Wisdom
  "PrayersToSpringtime", //Prayers to Springtime
  "ResolutionOfSojourner", //Resolution of Sojourner
  "RetracingBolide", //Retracing Bolide
  "Scholar", //Scholar
  "ShimenawasReminiscence", //Shimenawa's Reminiscence
  "TenacityOfTheMillelith", //Tenacity of the Millelith
  "TheExile", //The Exile
  "ThunderingFury", //Thundering Fury
  "Thundersoother", //Thundersoother
  "TinyMiracle", //Tiny Miracle
  "TravelingDoctor", //Traveling Doctor
  "VermillionHereafter", //Vermillion Hereafter
  "ViridescentVenerer", //Viridescent Venerer
  "WanderersTroupe",
] as const;
export type setKeyType = (typeof setKey)[number];

export const slotKey = [
  "flower",
  "plume",
  "sands",
  "goblet",
  "circlet",
] as const;
export type slotKeyType = (typeof slotKey)[number];

//Wanderer's Troupe
//   Adventurer: { name: { en: "Adventurer", ja: "" } },
//   ArchaicPetra: { name: { en: "Archaic Petra", ja: "" } },
//   Berserker: { name: { en: "Berserker", ja: "" } },
//   BlizzardStrayer: { name: { en: "Blizzard Strayer", ja: "" } },
//   BloodstainedChivalry: { name: { en: "Bloodstained Chivalry", ja: "" } },
//   BraveHeart: { name: { en: "Brave Heart", ja: "" } },
//   CrimsonWitchOfFlames: { name: { en: "Crimson Witch of Flames", ja: "" } },
//   DeepwoodMemories: { name: { en: "Deepwood Memories", ja: "" } },
//   DefendersWill: { name: { en: "Defender's Will", ja: "" } },
//   DesertPavilionChronicle: {
//     name: { en: "Desert Pavilion Chronicle", ja: "" },
//   },
//   EchoesOfAnOffering: { name: { en: "Echoes of an Offering", ja: "" } },
//   EmblemOfSeveredFate: { name: { en: "Emblem of Severed Fate", ja: "" } },
//   FlowerOfParadiseLost: { name: { en: "Flower of Paradise Lost", ja: "" } },
//   Gambler: { name: { en: "Gambler", ja: "" } },
//   GildedDreams: { name: { en: "Gilded Dreams", ja: "" } },
//   GladiatorsFinale: { name: { en: "Gladiator's Finale", ja: "" } },
//   HeartOfDepth: { name: { en: "Heart of Depth", ja: "" } },
//   HuskOfOpulentDreams: { name: { en: "Husk of Opulent Dreams", ja: "" } },
//   Instructor: { name: { en: "Instructor", ja: "" } },
//   Lavawalker: { name: { en: "Lavawalker", ja: "" } },
//   LuckyDog: { name: { en: "Lucky Dog", ja: "" } },
//   MaidenBeloved: { name: { en: "Maiden Beloved", ja: "" } },
//   MartialArtist: { name: { en: "Martial Artist", ja: "" } },
//   NoblesseOblige: { name: { en: "Noblesse Oblige", ja: "" } },
//   OceanHuedClam: { name: { en: "Ocean-Hued Clam", ja: "" } },
//   PaleFlame: { name: { en: "Pale Flame", ja: "" } },
//   PrayersForDestiny: { name: { en: "Prayers for Destiny", ja: "" } },
//   PrayersForIllumination: { name: { en: "Prayers for Illumination", ja: "" } },
//   PrayersForWisdom: { name: { en: "Prayers for Wisdom", ja: "" } },
//   PrayersToSpringtime: { name: { en: "Prayers to Springtime", ja: "" } },
//   ResolutionOfSojourner: { name: { en: "Resolution of Sojourner", ja: "" } },
//   RetracingBolide: { name: { en: "Retracing Bolide", ja: "" } },
//   Scholar: { name: { en: "Scholar", ja: "" } },
//   ShimenawasReminiscence: { name: { en: "Shimenawa's Reminiscence", ja: "" } },
//   TenacityOfTheMillelith: { name: { en: "Tenacity of the Millelith", ja: "" } },
//   TheExile: { name: { en: "The Exile", ja: "" } },
//   ThunderingFury: { name: { en: "Thundering Fury", ja: "" } },
//   Thundersoother: { name: { en: "Thundersoother", ja: "" } },
//   TinyMiracle: { name: { en: "Tiny Miracle", ja: "" } },
//   TravelingDoctor: { name: { en: "Traveling Doctor", ja: "" } },
//   VermillionHereafter: { name: { en: "Vermillion Hereafter", ja: "" } },
//   ViridescentVenerer: { name: { en: "Viridescent Venerer", ja: "" } },
//   WanderersTroupe: { name: { en: "Wanderer's Troupe", ja: "" } },
// };
